import { Button } from "@alternative/components";
import React, { useRef } from "react";

const InputButton = (props) => {
  const { onClick, children, inputProps, buttonProps } = props;
  const ref = useRef();
  return (
    <>
      <input style={{ display: "none" }} ref={ref} type="file" {...inputProps} />
      <Button
        onClick={(e) => {
          ref.current.click();
          if (onClick) onClick(e);
        }}
        {...buttonProps}
      >
        {children}
      </Button>
    </>
  );
};
export default InputButton;
